import { UnverifiedValue } from "./types";

import {
  ALLOWED_CHAR_CLASS,
  DENIED_CHARS,
  ALLOWED_CHAR_WITH_FULLWIDTH_INPUT_CHAR_CLASS,
  HALFWIDTH_KATAKANA,
  JAPANESE_SCRIPT_CHAR_CLASS,
} from "./constants";

/**
 * 未入力を検出
 */
export function isEmpty(value: UnverifiedValue): boolean {
  return value === "";
}

/**
 * 先頭・末尾にスペース（全角・半角両方）を検出
 */
export function hasLeadingOrTrailingSpace(value: UnverifiedValue): boolean {
  return value !== value.trim();
}

/**
 * 連続スペース（全角・半角両方）を検出
 */
export function hasConsecutiveSpaces(value: UnverifiedValue): boolean {
  return /\s{2,}/.test(value);
}

/**
 * 日本語（ひらがな、全角カタカナ、漢字・々）を検出
 * 全角中点（・）は記号のため含めない（hasAllowedCharWithFullwidthInput で検出）
 */
export function hasJapaneseScript(value: UnverifiedValue): boolean {
  return new RegExp(`[${JAPANESE_SCRIPT_CHAR_CLASS}]`, "u").test(value);
}

/**
 * 半角カタカナを検出
 */
export function hasHalfWidthKatakana(value: UnverifiedValue): boolean {
  return new RegExp(`[${HALFWIDTH_KATAKANA}]`, "u").test(value);
}

/**
 * 許可記号・英数字の全角入力を検出（半角強制の対象）
 * 「」、。は例外のため検出しない。未許可記号は hasDisallowedCharacter で行う
 */
export function hasAllowedCharWithFullwidthInput(value: UnverifiedValue): boolean {
  return new RegExp(`[${ALLOWED_CHAR_WITH_FULLWIDTH_INPUT_CHAR_CLASS}]`, "u").test(value);
}

/**
 * 特別に不許可とする文字を検出
 */
export function hasDeniedCharacter(value: UnverifiedValue): boolean {
  return new RegExp(`[${DENIED_CHARS}]`, "u").test(value);
}

/**
 * 使用可能文字種以外（拒否文字含む）を検出する
 */
export function hasDisallowedCharacter(value: UnverifiedValue): boolean {
  return new RegExp(`[^${ALLOWED_CHAR_CLASS}]`, "u").test(value) || hasDeniedCharacter(value);
}

/**
 * 入力文字数が上限文字数を超えているかの判定
 * @param value 入力文字
 * @param maxLength 上限文字数
 * @return boolean 上限文字数以上なら true
 */
export function isOverMaxLength(value: UnverifiedValue, maxLength: number): boolean {
  return value.length > maxLength;
}
